import i18next from 'i18next';
import { toast } from 'react-toastify';

export const toastErrorFromInternalCode = (codeValidationFunc, resource, key) => (_, response) => {
  const internalCode = response?.data?.[0]?.internal_code;
  toast.error(
    i18next.t(`${resource}:${key}${codeValidationFunc(internalCode) ? `Code${internalCode}` : ''}`)
  );
};
